module.exports = __webpack_public_path__ + "img/image4.396c3897.jpg";